const Ignis = {
  symbol: 'ignis',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM14.812 6c-1.004 2.89-2.2 5.715-3.247 8.59.727 1.298 1.417 2.615 2.153 3.906l5.545-9.671C17.758 7.915 16.33 6.888 14.812 6zM10 26c1.595-.034 3.188-.014 4.783-.014C17.17 21.745 19.594 17.523 22 13.29a1620.39 1620.39 0 0 1-2.496-4.37C16.4 14.645 13.139 20.291 10 26zm5.082-.023c2.12-1.249 4.239-2.5 6.345-3.775-.797-1.032-1.612-2.053-2.415-3.08-1.347 2.264-2.6 4.58-3.93 6.855z" fill-rule="evenodd"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#f9c011" r="16"/><path d="M14.812 6c1.518.887 2.946 1.914 4.45 2.825l-5.544 9.671c-.736-1.291-1.426-2.608-2.153-3.906 1.047-2.875 2.243-5.7 3.247-8.59zM10 26c3.139-5.709 6.4-11.355 9.504-17.079.83 1.457 1.661 2.913 2.496 4.37-2.406 4.232-4.83 8.454-7.217 12.695-1.595 0-3.188-.02-4.783.014zm5.082-.023c1.33-2.275 2.583-4.59 3.93-6.855.803 1.027 1.618 2.048 2.415 3.08a613.917 613.917 0 0 1-6.345 3.775z" fill="#fff" fill-rule="nonzero"/></g>`;
  }
};
export default Ignis;
